import type { HTMLAttributes } from "react"

import { cn } from "@/lib/utils"

export default function InputError({
  messages,
  className = "",
  ...props
}: HTMLAttributes<HTMLParagraphElement> & { messages?: string | string[] }) {
  if (!messages) return null

  return (
    <p
      {...props}
      className={cn("text-sm text-red-600 dark:text-red-400", className)}
    >
      {Array.isArray(messages) ? messages.join(", ") : messages}
    </p>
  )
}
